import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=f6096346&"
import script from "./calendar.vue?vue&type=script&lang=js&"
export * from "./calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QInput,QSelect,QDate,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QInput,QSelect,QDate,QInnerLoading,QSpinnerGears}, component.options.components || {})
